import React, { useState } from 'react';
import './contact.css';
import { FiMail, FiSend, FiCopy, FiCheck, FiArrowUpRight, FiGithub, FiLinkedin } from 'react-icons/fi';
import { BsWhatsapp, BsTelegram } from 'react-icons/bs';
import { profile } from '../../data/profile';

const channels = [
  {
    id: 'email',
    icon: <FiMail />,
    label: 'Email',
    value: profile.email,
    href: `mailto:${profile.email}`,
    action: 'Send an email',
    primary: true,
  },
  {
    id: 'whatsapp',
    icon: <BsWhatsapp />,
    label: 'WhatsApp',
    value: profile.phone,
    href: profile.whatsapp,
    action: 'Start a chat',
  },
  {
    id: 'telegram',
    icon: <BsTelegram />,
    label: 'Telegram',
    value: `@${profile.telegram}`,
    href: `https://t.me/${profile.telegram}`,
    action: 'Message me',
  },
  {
    id: 'linkedin',
    icon: <FiLinkedin />,
    label: 'LinkedIn',
    value: 'in/fantahun-fekadu',
    href: profile.linkedin,
    action: 'Connect',
  },
];

const Contact = () => {
  const [copied, setCopied] = useState(false);

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(profile.email);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      // Clipboard unavailable (insecure context or denied) — the mailto link still works.
      setCopied(false);
    }
  };

  return (
    <section id="contact">
      <div className="container">
        <div className="contact__panel reveal">
          <div className="contact__intro">
            <span className="section__eyebrow">05 — Contact</span>
            <h2>
              Have an AI system or a backend that
              <br />
              needs to <span className="text-gradient">actually hold up?</span>
            </h2>
            <p>
              I&apos;m open to lead and senior roles in AI/ML and backend engineering, plus
              selective contract work. Tell me what you&apos;re building and where it hurts —
              I&apos;ll tell you honestly whether I&apos;m the right person for it.
            </p>

            <div className="contact__cta">
              <a href={`mailto:${profile.email}`} className="btn btn-primary">
                <FiSend />
                {profile.email}
              </a>
              <button type="button" className="btn contact__copy" onClick={copyEmail}>
                {copied ? <FiCheck /> : <FiCopy />}
                {copied ? 'Copied' : 'Copy'}
              </button>
            </div>

            <p className="contact__note mono">
              Based in {profile.location} ({profile.timezone}) · usually replies within a day
            </p>
          </div>

          <div className="contact__channels">
            {channels.map((channel) => (
              <a
                key={channel.id}
                href={channel.href}
                target={channel.id === 'email' ? undefined : '_blank'}
                rel="noreferrer"
                className={`contact__channel ${channel.primary ? 'is-primary' : ''}`}
              >
                <span className="contact__channel-icon">{channel.icon}</span>
                <span className="contact__channel-body">
                  <span className="contact__channel-label">{channel.label}</span>
                  <span className="contact__channel-value">{channel.value}</span>
                </span>
                <FiArrowUpRight className="contact__channel-arrow" />
              </a>
            ))}

            <a
              href={profile.github}
              target="_blank"
              rel="noreferrer"
              className="contact__channel"
            >
              <span className="contact__channel-icon">
                <FiGithub />
              </span>
              <span className="contact__channel-body">
                <span className="contact__channel-label">GitHub</span>
                <span className="contact__channel-value">github.com/FANIMAN</span>
              </span>
              <FiArrowUpRight className="contact__channel-arrow" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
